goog.provide('el8.appchart.actions.medOrderThread');

goog.require('el8.appchart.dialog.ordermed.discontinue');
goog.require('el8.appchart.dialog.ordermed.documentDiscontinue');
goog.require('el8.appchart.dialog.ordermed.txStartDate');
goog.require('el8.appchart.permissions');
goog.require('el8.ptdata.medOrderThreads');
goog.require('el8.uiwidget.deleteConfirm');
goog.require('el8.util.amplitude.prescriptionFormHelpers');


el8.appchart.actions.medOrderThread = function(opts) {

    opts = opts || {};
    var item = opts.item;  // medOrderThread
    var latestOrder = item.getLatestOrder();
    var isMedsHistory = (opts.isMedsHistory === true); // defaults to false
    var menu = [];

    if (item.isRxDownload()) {
        if (isMedsHistory) {
          menu.push({
              actionText: 'View Last Script',
              actionFn: function() {
                  el8.appchart.showItemDetail(latestOrder);
                  return false;
              }
          });
        } else {
          menu.push({
              actionText: 'View History',
              actionFn: function() {
                  el8.appchart.medsHx.main.show({threadId: item.getId()});
              }
          });
        }
        if (el8.appchart.permissions.allow('acknowledgeRxDownloads')) {
            menu.push({
                actionText: 'Sign Off',
                actionFn: function() {
                    el8.appchart.medsMgr.acknowledgeRxDownloadThread(item.getId());
                }
            });
        }
    } else {  // real non-RxDownload threads

      if (latestOrder.is('MedOrder')) {
          menu.push({
              actionText: 'Rx: Refill',
              actionFn: function() {
                  if (opts.amplitudeSource) {
                      el8.util.amplitude.logStartPrescription(
                          opts.amplitudeSource,
                          el8.appchart.mgr.orderForm.getPrintFormType(latestOrder)
                      );
                  }
                  el8.appchart.mgr.orderForm.refillMedOrder(latestOrder);
              }
          });
          menu.push({
              actionText: 'Rx: Change Dose',
              actionFn: function() {
                  if (opts.amplitudeSource) {
                      el8.util.amplitude.logStartPrescription(
                          opts.amplitudeSource,
                          el8.appchart.mgr.orderForm.getPrintFormType(latestOrder)
                      );
                  }
                  el8.appchart.mgr.orderForm.changeMedOrder(latestOrder);
              }
          });
          if (el8.appchart.permissions.allow('prescribeMeds')) {
              menu.push({
                  actionText: 'Rx: Discontinue',
                  actionFn: function() {
                      el8.appchart.dialog.ordermed.discontinue.show({order: latestOrder});
                  }
              });
          }
          menu.push({
              actionText: 'Document Change',
              actionFn: function() {
                  var prescribingPhysicianId = latestOrder.getPrescribingPhysicianId();
                  var prescriberId;
                  if (prescribingPhysicianId) {
                    prescriberId = prescribingPhysicianId;
                  } else {
                    prescriberId = el8.data.currUser.isPhysician() ? el8.data.currUser.getStaffId() : null;
                  }
                  el8.appchart.dialog.ordermed.document.show({
                      order: latestOrder,
                      type: 'DoseChange',
                      prescriberId: prescriberId
                  });
              }
          });
      } else if (latestOrder.is('DiscontinueMedOrder')) {
          var medOrder = el8.ptdata.fetchById(latestOrder.getMedOrderId());
          menu.push({
              actionText: 'Rx: Re-Order',
              actionFn: function() {
                  if (opts.amplitudeSource) {
                      el8.util.amplitude.logStartPrescription(
                          opts.amplitudeSource,
                          el8.appchart.mgr.orderForm.getPrintFormType(medOrder)
                      );
                  }
                  el8.appchart.mgr.orderForm.reOrderMedOrder(medOrder);
              }
          });
          menu.push({
              actionText: 'Document Change',
              actionFn: function() {
                  el8.appchart.dialog.ordermed.document.show({
                      order: medOrder,
                      type: 'DoseChange',
                      prescriberId: el8.data.currUser.isPhysician() ?
                          el8.data.currUser.getStaffId() : null
                  });
              }
          });
      }
      if (latestOrder.is('MedOrder')) {
          menu.push({
              actionText: 'Document Discontinue',
              actionFn: function() {
                  el8.appchart.dialog.ordermed.documentDiscontinue.show({
                      order: latestOrder
                  });
              }
          });
      }
      if (!isMedsHistory) {
          menu.push({
              actionText: 'View History',
              actionFn: function() {
                  el8.appchart.medsHx.main.show({threadId: item.getId()});
              }
          });
      }
      menu.push({
          actionText: 'Export to Note (HPI)',
          actionFn: function() {
              el8.appchart.mgr.notes.addReference({item: latestOrder, sectionName: 'problem'});
          }
      });
      menu.push({
          actionText: 'Export to Note (Meds)',
          actionFn: function() {
              el8.appchart.mgr.notes.addReference({item: latestOrder});
          }
      });
      if (latestOrder.is('MedOrder')) {
          menu.push({
              actionText: 'Change Tx Start Date',
              actionFn: function() {
                  el8.appchart.dialog.ordermed.txStartDate.show(item.getId());
              }
          });
          menu.push({
              actionText: 'Set as ' +
                  (item.isPermanent() ? 'Temporary' : 'Permanent') +
                  ' Med',
              actionFn: function() {
                  el8.appchart.medsMgr.toggleThreadPermanence(item.getId());
              }
          });
          if (item.isPermanent()) {
              menu.push({
                  actionText: 'Move to ' +
                      (latestOrder.isPrescription() ? 'OTC' : 'Rx') +
                      ' Meds List',
                  actionFn: function() {
                      el8.appchart.medsMgr.toggleMedicationType(latestOrder.getId());
                  }
              });
          }
      }
      menu.push({
          actionText: 'Merge with Other Med',
          actionFn: function() {
              el8.appchart.medsHx.main.show({
                  threadId: item.getId(),
                  doMoveMerge: true
              });
          }
      });
      if (latestOrder.is('MedOrder') && !latestOrder.isDocumentMed()) {
          menu.push({
              actionText: 'View Last Script',
              actionFn: function() {
                  el8.appchart.showItemDetail(latestOrder);
                  return false;
              }
          });
          menu.push({
              actionText: 'Re-print Last Script',
              actionFn: function() {
                  el8.ptdata.medOrders.printSingle(latestOrder);
                  return false;
              }
          });
      }
      menu.push({
          actionText: 'Write Message',
          actionFn: function() {
              el8.appshared.message.prePopulateNewMessage({
                  toDocId: latestOrder.getId()
              });
          }
      });
    }

    if (!el8Globals.FEATURES.MDToolboxEPCS || !latestOrder.getMedication().isControlled() || latestOrder.isDocumentMed() || item.isRxDownload()) {
        // Hide the remove button if the med order is controlled substance or if the feature flag MDToolboxEPCS is turned on.
        // This prevents same day prescription of the same controlled substance for the same patient, which is forbidden.
        // Only limit removal for prescriptions, allow doc'd meds and meds history downlaod records to be deleted.
        menu.push({
            actionText: 'Remove Medication',
            actionFn: function() {
                var confirmStr = "medication as well as its prescription history";
                var customBtnOpts = (!isMedsHistory) ?
                    { text: 'View Medication History', fn: function() { el8.appchart.medsHx.main.show({threadId: item.getId()}); } } : null;
                el8.uiwidget.deleteConfirm(confirmStr,
                    function() {
                        // if we're looking at this thread in meds hx:  go back to the all-threads view before deleting
                        if (el8.appchart.medsHx.main.isShowing(item.getId())) {
                            el8.appchart.medsHx.main.clearContents(function() {
                                el8.ptdata.medOrderThreads.deleteItem(item);
                            });
                        } else {
                            el8.ptdata.medOrderThreads.deleteItem(item);
                        }
                    }, // yesFn
                    null, // noFn
                    { customBtnOpts: customBtnOpts } // opts
                );
            }
        });
    }

    return menu;
};
